import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { RespiAllerReferralData } from './respiAllerReferralSchemaV1';

export type RespiAllerReferralReadLabelV1 =
    | 'Verstuurd naar'
    | 'Patiënt'
    | 'Vraag aan allergoloog'
    | 'Anamnese'
    | 'Allergiën'
    | 'Episodes en journaalregels'
    | 'Diagnostische bepalingen'
    | 'Geschiedenis'
    | 'Telefoonnummer'
    | 'Mobiel telefoonnummer'
    | 'E-mail'
    | 'Klachten'
    | 'Voorgeschiedenis'
    | 'Familiaire voorgeschiedenis'
    | 'Medicatie'
    | 'Patiënt gebruikt(e) medicatie';

export type RespiAllerReferralReadDataV1 = RespiAllerReferralData & {
    anamnesisComplaints: string;
    anamnesisFamilyHistory: string;
    anamnesisHistory: string;
    episodesAndJournalsEpisodes: string;
    episodesAndJournalsJournalEntries: string;
    patientEmailAddress: string;
    patientHomePhoneNumber: string;
    patientMobileNumber: string;
    referralSendTo: string;
};

export type RespiAllerReferralReadKeyV1 = keyof RespiAllerReferralReadDataV1;

export const respiAllerReferralReadSectionsV1: TypedReadSchema<
    RespiAllerReferralReadKeyV1,
    RespiAllerReferralReadLabelV1
>[] = [
    {
        items: [{ key: 'referralSendTo', label: 'Verstuurd naar' }],
        sectionTitle: 'Verwijzing',
    },
    {
        items: [
            { key: 'anamnesisComplaints', label: 'Klachten' },
            { key: 'anamnesisHistory', label: 'Voorgeschiedenis' },
            { key: 'anamnesisFamilyHistory', label: 'Familiaire voorgeschiedenis' },
        ],
        sectionTitle: 'Anamnese',
    },
    {
        items: [
            { key: 'patientUsesMedication', label: 'Patiënt gebruikt(e) medicatie', type: 'boolean' },
            { key: 'medications', label: 'Medicatie' },
        ],
        sectionTitle: 'Medicatie',
    },
    {
        items: [
            { key: 'allergies', label: 'Allergiën' },
            { key: 'episodesAndJournals', label: 'Episodes en journaalregels' },
            { key: 'labResults', label: 'Diagnostische bepalingen' },
        ],
        sectionTitle: 'Professionele samenvatting',
    },
    {
        items: [
            { key: 'patientHomePhoneNumber', label: 'Telefoonnummer' },
            { key: 'patientMobileNumber', label: 'Mobiel telefoonnummer' },
            { key: 'patientEmailAddress', label: 'E-mail' },
        ],
        sectionTitle: 'Contactgegevens patiënt',
    },
];
